import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '#configuration/tokenHandling/prepareHeaders.ts';

import { config } from '../config';

export const apiOrderCommunicationBooking = createApi({
    reducerPath: 'apiOrderCommunicationBooking',
    baseQuery: fetchBaseQuery({
        baseUrl: config.orderCommunicationBookingApi,
        mode: 'cors',
        prepareHeaders,
    }),
    endpoints: () => ({}),
});
